module.exports = __webpack_public_path__ + "static/media/0008.6112e9f0.jpg";